"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayVerticalLineCircle = void 0;
var React = __importStar(require("react"));
var PlayVerticalLineCircle = function (_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 48 48"
  }, React.createElement("g", {
    transform: "translate(203 90)"
  }, React.createElement("g", null, React.createElement("rect", {
    x: "-173",
    y: "-78.1",
    width: "4",
    height: "24.1"
  })), React.createElement("path", {
    d: "M-160-66c0,10.5-8.5,19-19,19c-10.5,0-19-8.5-19-19c0-10.5,8.5-19,19-19C-168.5-85-160-76.5-160-66\n\t\t M-156-66c0-12.7-10.3-23-23-23s-23,10.3-23,23s10.3,23,23,23S-156-53.3-156-66z"
  }), React.createElement("path", {
    d: "M-189-55.7v-20.7l12.1,10.4L-189-55.7z M-185-67.7v3.3l1.9-1.6L-185-67.7z"
  })));
};
exports.PlayVerticalLineCircle = PlayVerticalLineCircle;